import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ToastService } from '../../../core/services/toast.service';
import { TranslateService } from '@ngx-translate/core';
import { StaticPagesService } from 'src/app/views/static-pages/static-pages.service';

@Component({
    selector: 'app-partner-form-modal',
    templateUrl: './partner-form-modal.component.html',
    styleUrls: ['./partner-form-modal.component.scss']
})
export class PartnerFormModalComponent implements OnInit {

    @Output() closed = new EventEmitter<void>();

    partnerForm!: FormGroup;
    formSubmitting = false;
    formSuccess = false;
    submitted = false;

    partnerTypeOptions = [
        { value: 'AFFILIATE', labelKey: 'partnerFormModal.options.AFFILIATE' },
        { value: 'PROFESSIONAL_REFERRER', labelKey: 'partnerFormModal.options.PROFESSIONAL_REFERRER' },
        { value: 'SOLUTION_PARTNER', labelKey: 'partnerFormModal.options.SOLUTION_PARTNER' },
        { value: 'ACADEMIC_COMMUNITY_PARTNER', labelKey: 'partnerFormModal.options.ACADEMIC_COMMUNITY_PARTNER' },
    ];

    constructor(
        private fb: FormBuilder,
        private toast: ToastService,
        private translateService: TranslateService,
        private staticPagesService: StaticPagesService,
    ) {}

    ngOnInit(): void {
        this.partnerForm = this.fb.group({
            fullName: ['', Validators.required],
            email: ['', [Validators.required, Validators.email]],
            organization: ['', Validators.required],
            partnerType: ['', Validators.required],
            commissionTier: ['Affiliates (6–10%)'],
            interest: [''],
        });
    }

    isFieldInvalid(field: string): boolean {
        const control = this.partnerForm.get(field);
        return !!(control && control.invalid && (control.dirty || control.touched || this.submitted));
    }

    async onSubmit(): Promise<void> {
        this.submitted = true;
        if (this.partnerForm.invalid) {
            this.partnerForm.markAllAsTouched();
            return;
        }
        this.formSubmitting = true;
        try {
            const res = await this.staticPagesService.submitPartnerContact(this.partnerForm.value);
            if (res && res.status) {
                this.formSuccess = true;
                this.partnerForm.reset();
                this.submitted = false;
            } else {
                this.toast.error(res?.message || 'Something went wrong. Please try again.');
            }
        } catch {
            this.toast.error('Failed to submit. Please try again later.');
        } finally {
            this.formSubmitting = false;
        }
    }

    close(): void {
        this.closed.emit();
    }
}
